import React, { Fragment } from "react";
import { withFormik } from "formik";
import * as Yup from "yup";
import UnitOfMeasurementForm from "./UnitOfMeasurementForm";
import { Card, CardHeader, CardBody, Col, Spinner } from "reactstrap";
import firebase from "config/firebase";
import idx from "idx";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useGetUnitiesOfMeasurement } from "hooks";
import { CenteredSpinner } from "components";
import dispatch, { EditActions } from "actions";

const UnitOfMeasurementDetails = ({ isModal = false, closeModal }) => {
  const history = useHistory();
  const isEdit =
    !isModal && idx(history, (_) => _.location.state.row.id) ? true : false;
  const id = idx(history, (_) => _.location.state.row.id);
  const user = useSelector((state) => state.user);
  const db = firebase.firestore();

  const {
    loadingUnitiesOfMeasurement,
    unitiesOfMeasurement,
    unitiesOfMeasurementNames,
  } = useGetUnitiesOfMeasurement();

  const formikEnhancer = withFormik({
    validationSchema: Yup.object().shape({
      name: Yup.string().required("Insira o nome da unidade de medida"),
    }),
    validate: (values) => {
      const errors = {};
      if (values.name && unitiesOfMeasurementNames) {
        if (unitiesOfMeasurementNames.indexOf(values.name) > -1)
          errors.name = "Nome já registrado";
      }
      return errors;
    },
    handleSubmit: (values, { setSubmitting }) => {
      const newUnitOfMeasurement = {
        name: values.name,
      };

      const docId = isEdit
        ? id
        : db.collection("unitiesOfMeasurement").doc().id;
      newUnitOfMeasurement["id"] = docId;

      let serverTimestamp = firebase.firestore.FieldValue.serverTimestamp();

      if (isEdit) {
        newUnitOfMeasurement["createdAt"] = values["createdAt"];
        newUnitOfMeasurement["updatedAt"] = serverTimestamp;
      } else {
        newUnitOfMeasurement["createdAt"] = serverTimestamp;
      }

      const docRef = db.collection("unitiesOfMeasurement").doc(docId);
      const logRef = db.collection("logs").doc();

      const log = {
        action: "create",
        reference: newUnitOfMeasurement["name"],
        collection: "unitiesOfMeasurement",
        doc: docId,
        createdAt: serverTimestamp,
        user,
      };

      let batch = db.batch();
      if (isEdit) {
        log["action"] = "update";
        batch.update(docRef, newUnitOfMeasurement);
      } else {
        batch.set(docRef, newUnitOfMeasurement);
      }
      batch.set(logRef, log);

      batch
        .commit()
        .then(() => {
          console.log("Unidade de medida salva com sucesso");
          setSubmitting(false);
          {
            isModal ? closeModal() : history.goBack();
          }
        })
        .catch(function (error) {
          alert("Erro ao salvar unidade de medida");
          console.error("Erro ao salvar unidade de medida: ", error);
          setSubmitting(false);
        });
      dispatch(EditActions.setWarning, { warning: false });
    },
    displayName: "UnitOfMeasurementForm",
    mapPropsToValues: () => {
      let data = {
        name: "",
        createdAt: "",
      };
      if (isEdit) {
        const row = history.location.state.row;
        data = {
          name: row.name,
          createdAt: row.createdAt,
        };
      }
      return data;
    },
  });

  const MyEnhancedForm = formikEnhancer(UnitOfMeasurementForm);

  if (isModal)
    return (
      <Fragment>
        {loadingUnitiesOfMeasurement ? <CenteredSpinner /> : <MyEnhancedForm />}
      </Fragment>
    );
  return (
    <div className="animated">
      <Card>
        <CardHeader>Unidade de medida</CardHeader>
        <CardBody>
          {loadingUnitiesOfMeasurement ? (
            <CenteredSpinner />
          ) : (
            <MyEnhancedForm />
          )}
        </CardBody>
      </Card>
    </div>
  );
};

export default UnitOfMeasurementDetails;
